/** @format */

import React, { PureComponent } from 'react';
import compose from 'recompose/compose';
import withStyles from '@material-ui/core/styles/withStyles';
import adescomStyle from '../../../assets/jss/adescom/adescomStyle';
import { Button, Dialog, DialogContent, DialogTitle } from '@material-ui/core';
import I18n from '../../../components/Translate/I18n';
import { ReactComponent as Cancel } from '../../../assets/themes/OPL/img/icons/Cancel.svg';
import GridContainer from '../../../components/Grid/GridContainer';

interface ApiDialogProps {
    open: boolean;
    title: string | any | null;
    content: PureComponent | null;
    fullWidth: boolean;

    closeCallback(): void;
}

class ApiDialog extends PureComponent<ApiDialogProps> {
    render():
        | React.ReactElement<any, string | React.JSXElementConstructor<any>>
        | string
        | number
        | {}
        | React.ReactNodeArray
        | React.ReactPortal
        | boolean
        | null
        | undefined {
        const { open, content, title, closeCallback, fullWidth } = this.props;
        return (
            <Dialog
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
                keepMounted
                open={open}
                fullWidth={fullWidth}
                maxWidth="lg"
            >
                <DialogTitle>
                    <GridContainer justifyContent={'space-between'}>
                        <h4>
                            {title === null && ''}
                            {typeof title === 'string' ? <I18n trans={title} /> : title}
                        </h4>
                        <Button onClick={closeCallback} color="primary">
                            <Cancel width={24} height={24} />
                        </Button>
                    </GridContainer>
                </DialogTitle>
                <DialogContent>{content}</DialogContent>
            </Dialog>
        );
    }
}

export default compose<any, any>(withStyles(adescomStyle))(ApiDialog);
